import React, { useEffect, useState, lazy, memo } from 'react';
import { CheckCircleIcon, ArrowRightIcon, BadgeCheckIcon, ShieldCheckIcon, ThumbsUpIcon, StarIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
const HowItWorks = () => {
  const handleCTAClick = () => {
    // Registrar evento de Add to Cart
    trackAddToCart();
    // Abrir el checkout en la misma página
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  // Estado para el contador de stock
  const [stockCount, setStockCount] = useState(12);
  // Efecto para reducir el stock aleatoriamente
  useEffect(() => {
    const stockTimer = setInterval(() => {
      setStockCount(prevStock => {
        // Reducir stock aleatoriamente entre 1-2 unidades
        const reduction = Math.floor(Math.random() * 2) + 1;
        const newStock = Math.max(prevStock - reduction, 3); // No bajar de 3 unidades
        return newStock;
      });
    }, 45000); // Cada 45 segundos
    return () => clearInterval(stockTimer);
  }, []);
  // Estado para las animaciones de los beneficios
  const [activePoint, setActivePoint] = useState(0);
  // Rotar entre los puntos de beneficios
  useEffect(() => {
    const pointsTimer = setInterval(() => {
      setActivePoint(prev => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(pointsTimer);
  }, []);
  return <section id="how-it-works" className="py-16 md:py-24 bg-[#f8f9ff]" data-id="element-301">
      <div className="container mx-auto px-4 md:px-6" data-id="element-302">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-303">
          <div className="md:w-1/2" data-id="element-304">
            <div className="relative" data-id="element-305">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#8b5cf6] to-[#4ade80] rounded-2xl blur opacity-20" data-id="element-306"></div>
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-1" data-id="element-307">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m4cYenXFttBhuGpiyEiict/ChatGPT_Image_8_sept_2025%2C_10_15_26_a.m..png" alt="Corona de Alivio 360 en uso - Máscara púrpura con tecnología de frío/calor" className="w-full h-auto rounded-xl" width="600" height="400" loading="lazy" data-id="element-308" />
                {/* Sello de certificación */}
                <div className="absolute top-4 right-4 bg-white text-[#1e293b] text-xs font-bold p-2 rounded-full shadow-lg flex items-center" data-id="element-309">
                  <ShieldCheckIcon size={16} className="text-[#4ade80] mr-1" data-id="element-310" />
                  <span data-id="element-311">CERTIFICADO</span>
                </div>
                {/* Indicador de stock */}
                <div className="absolute bottom-4 left-4 bg-white bg-opacity-90 text-[#1e293b] text-xs font-bold p-2 rounded-lg shadow-lg" data-id="element-312">
                  <div className="flex items-center" data-id="element-313">
                    <span className="text-red-500 animate-pulse mr-1" data-id="element-314">●</span>
                    <span data-id="element-315">
                      ¡Solo quedan <strong data-id="element-316">{stockCount}</strong> unidades en
                      stock!
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Sellos de credibilidad */}
            <div className="mt-6 flex flex-wrap justify-center gap-4" data-id="element-317">
              <div className="bg-white p-2 rounded-lg shadow-sm flex items-center" data-id="element-318">
                <BadgeCheckIcon size={16} className="text-[#6366f1] mr-1" data-id="element-319" />
                <span className="text-xs font-medium" data-id="element-320">
                  Aprobado por especialistas
                </span>
              </div>
              <div className="bg-white p-2 rounded-lg shadow-sm flex items-center" data-id="element-321">
                <ThumbsUpIcon size={16} className="text-[#6366f1] mr-1" data-id="element-322" />
                <span className="text-xs font-medium" data-id="element-323">
                  12,000+ usuarios satisfechos
                </span>
              </div>
              <div className="bg-white p-2 rounded-lg shadow-sm flex items-center" data-id="element-324">
                <StarIcon size={16} className="text-[#f59e0b] fill-[#f59e0b] mr-1" data-id="element-325" />
                <span className="text-xs font-medium" data-id="element-326">
                  4.8/5 estrellas (487 reseñas)
                </span>
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-327">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-[#1e293b]" data-id="element-328">
              Cómo funciona
            </h2>
            <div className="space-y-6" data-id="element-329">
              <p className="text-lg text-[#4a5568]" data-id="element-330">
                Imagina colocarlo suavemente en tu cabeza... Sientes el contacto
                frío-calor, como un abrazo terapéutico. Respiras... y tu mente
                empieza a soltar.
              </p>
              <p className="text-lg text-[#4a5568]" data-id="element-331">
                Tu cuerpo entra en modo reparación. Tu sistema nervioso se
                regula. Y el dolor simplemente... desaparece.
              </p>
              {/* Nota del especialista */}
              <div className="bg-[#eef2ff] p-4 rounded-lg border-l-4 border-[#6366f1] my-6" data-id="element-332">
                <div className="flex items-start" data-id="element-333">
                  <img src="https://randomuser.me/api/portraits/men/42.jpg" alt="Dr. Martínez" className="w-12 h-12 rounded-full mr-4 border-2 border-white shadow-sm" data-id="element-334" />
                  <div data-id="element-335">
                    <p className="text-[#1e293b] font-medium" data-id="element-336">
                      Dr. Alejandro Martínez
                    </p>
                    <p className="text-sm text-[#4a5568] mb-2" data-id="element-337">
                      Neurólogo, Especialista en Dolor
                    </p>
                    <p className="text-[#4a5568] italic" data-id="element-338">
                      "Este dispositivo utiliza principios científicos
                      comprobados para atacar el dolor desde múltiples ángulos.
                      Es una alternativa efectiva y sin químicos que recomiendo
                      a mis pacientes."
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-6 p-4 bg-[#f0f4ff] rounded-lg border border-[#dbeafe]" data-id="element-339">
                <h3 className="text-lg font-medium text-[#1e293b] mb-2" data-id="element-340">
                  Modo de uso recomendado:
                </h3>
                <ul className="space-y-2 text-[#4a5568]" data-id="element-341">
                  <li data-id="element-342">• 10-20 minutos usando el modo frío</li>
                  <li data-id="element-343">• 10 minutos usando el modo caliente</li>
                  <li data-id="element-344">• Usar según tu conveniencia y necesidad</li>
                </ul>
              </div>
              <div className="mt-8 space-y-4" data-id="element-345">
                <h3 className="text-2xl font-semibold text-[#1e293b]" data-id="element-346">
                  Piensa en ese momento:
                </h3>
                <div className={`flex items-start transition-all duration-300 ${activePoint === 0 ? 'bg-[#f0fdf4] p-3 rounded-lg transform scale-105' : ''}`} data-id="element-347">
                  <CheckCircleIcon size={24} className={`${activePoint === 0 ? 'text-[#22c55e]' : 'text-[#4ade80]'} mt-1 mr-3 shrink-0 ${activePoint === 0 ? 'animate-bounce' : ''}`} data-id="element-348" />
                  <p className="text-lg text-[#4a5568]" data-id="element-349">
                    Te despiertas sin dolor.
                  </p>
                </div>
                <div className={`flex items-start transition-all duration-300 ${activePoint === 1 ? 'bg-[#f0fdf4] p-3 rounded-lg transform scale-105' : ''}`} data-id="element-350">
                  <CheckCircleIcon size={24} className={`${activePoint === 1 ? 'text-[#22c55e]' : 'text-[#4ade80]'} mt-1 mr-3 shrink-0 ${activePoint === 1 ? 'animate-bounce' : ''}`} data-id="element-351" />
                  <p className="text-lg text-[#4a5568]" data-id="element-352">
                    Te mueves con energía.
                  </p>
                </div>
                <div className={`flex items-start transition-all duration-300 ${activePoint === 2 ? 'bg-[#f0fdf4] p-3 rounded-lg transform scale-105' : ''}`} data-id="element-353">
                  <CheckCircleIcon size={24} className={`${activePoint === 2 ? 'text-[#22c55e]' : 'text-[#4ade80]'} mt-1 mr-3 shrink-0 ${activePoint === 2 ? 'animate-bounce' : ''}`} data-id="element-354" />
                  <p className="text-lg text-[#4a5568]" data-id="element-355">Sonríes sin peso.</p>
                </div>
                <div className={`flex items-start transition-all duration-300 ${activePoint === 3 ? 'bg-[#f0fdf4] p-3 rounded-lg transform scale-105' : ''}`} data-id="element-356">
                  <CheckCircleIcon size={24} className={`${activePoint === 3 ? 'text-[#22c55e]' : 'text-[#4ade80]'} mt-1 mr-3 shrink-0 ${activePoint === 3 ? 'animate-bounce' : ''}`} data-id="element-357" />
                  <p className="text-lg text-[#4a5568]" data-id="element-358">
                    Vuelves a disfrutar de lo simple.
                  </p>
                </div>
              </div>
              <p className="text-lg text-[#4a5568] italic mt-6" data-id="element-359">
                Tu paz interior ya no es interrumpida. Y recuerdas que todo
                empezó con una decisión pequeña, aquí y ahora.
              </p>
              {/* Gatillo de urgencia */}
              <div className="bg-[#fffbeb] border border-[#fef3c7] p-3 rounded-lg my-4" data-id="element-360">
                <p className="text-[#b45309] text-sm font-medium" data-id="element-361">
                  Las personas que toman acción ahora mismo reportan un 78% más
                  de probabilidades de experimentar alivio completo.
                </p>
              </div>
              <div className="mt-8" data-id="element-362">
                <button onClick={handleCTAClick} className="bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-8 py-4 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-lg group relative overflow-hidden" data-id="element-363">
                  <span className="relative z-10 flex items-center justify-center" data-id="element-364">
                    Quiero vivir sin dolor
                    <ArrowRightIcon size={20} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-365" />
                  </span>
                  <span className="absolute inset-0 bg-gradient-to-r from-[#8b5cf6] to-[#6366f1] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-366"></span>
                </button>
              </div>
              {/* Contador de personas que lo compraron hoy */}
              <div className="mt-4 text-center" data-id="element-367">
                <p className="text-sm text-[#6366f1]" data-id="element-368">
                  <strong data-id="element-369">47 personas</strong> han tomado esta decisión hoy
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(HowItWorks);